import { defineStore } from 'pinia'
import { CAMPAIGN_CONFIG } from '../utils/config'

const CACHE_KEY = 'thx-counter-total'

// The last number that was fetched, so a failed fetch can still show something.
const readCache = () => {
  try {
    const value = Number.parseInt(localStorage.getItem(CACHE_KEY))
    return Number.isNaN(value) ? null : value
  } catch {
    return null
  }
}

const writeCache = (value) => {
  try {
    localStorage.setItem(CACHE_KEY, String(value))
  } catch {
    // Storage is not available, for example in private mode.
  }
}

export const useCounterStore = defineStore('counter', {
  state: () => ({
    total: null,
    // The number could not be fetched and there is no earlier number to show.
    failed: false,
  }),
  actions: {
    // Resolves to whether a fresh number was fetched.
    async fetchCounter() {
      try {
        const { spreadsheetId, range, refreshIntervalMs } = CAMPAIGN_CONFIG
        // The service keeps its answer for 60 seconds. A parameter that changes every window gets a fresh answer, and everyone in
        // the same window still shares one.
        const bucket = Math.floor(Date.now() / refreshIntervalMs)
        const response = await fetch(
          `https://spreadsheet.radio.dpgmedia.cloud/prod/fetch?spreadsheetId=${spreadsheetId}&provider=google&range=${range}&_=${bucket}`
        )
        if (!response.ok) {
          throw new Error(`Spreadsheet request failed [${response.status}]`)
        }
        // The range is one column with a header row, so the answer is a single row with a single value.
        const [row] = await response.json()
        const total = Number.parseInt(Object.values(row ?? {})[0])
        if (Number.isNaN(total)) {
          throw new Error(`No number found in ${range}`)
        }

        this.total = total
        this.failed = false
        writeCache(this.total)
        return true
      } catch (e) {
        console.error(e)
        // Keep the last known total, or fall back to the one from an earlier visit.
        if (this.total === null) {
          this.total = readCache()
          this.failed = this.total === null
        }
        return false
      }
    },
  },
})
